import * as tokenService from '../services/token';

/**
 * Check if user is authenticated.
 *
 * @returns {boolean}
 */
export function isUserLogedIn() {
  return !!tokenService.getAccessToken();
}

/**
 * Redirect to home page if user is authenticated.
 */
export function redirectToHome() {
  if (isUserLogedIn()) {
    if (window.location.pathname === '/login') {
      window.location.pathname = '/home';
    }
  }
}
export function redirectToAdmin() {
  if (isUserLogedIn()) {
    if (window.location.pathname === '/login') {
      window.location.pathname = '/admin/standard-users';
    }
  }
}
